// ---------------------------------------------------------------------------
// Renders the handful of translation strings that intentionally carry markup
// (`heroTitle` and friends use <br> and <em> to break the headline).
//
// Only these tags survive: the content is editable from the admin panel, so it
// is sanitised rather than trusted.
// ---------------------------------------------------------------------------

const ALLOWED = /<(?!\/?(br|em|strong|b|i)\b)[^>]*>/gi;

export const sanitizeInline = (html) =>
  String(html ?? '')
    .replace(ALLOWED, '')
    .replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '');

export function RichText({ html, as: Tag = 'span', ...rest }) {
  return <Tag {...rest} dangerouslySetInnerHTML={{ __html: sanitizeInline(html) }} />;
}
